<template>
  <div style="" class="father">
    <wty-permission v-if="wtypermiss_show" :who="'permission'" :perssionData="perssionData" :tableList="tableList"
      :tableClumn="tableClumn"></wty-permission>
  </div>
</template>
<script>
import wtyPermission from "@/components/wty-permission.vue";
import { getServicePermissList } from "@/api/service.js";
export default {
  name: "Permission",
  components: { wtyPermission },
  data() {
    return {
      tableList: [],
      perssionData: {},
      wtypermiss_show: true,
      tableClumn: [
        {
          prop: "account_name",
          align: "center",
          label: "名字",
          width: "200",
          fixed: "left"
        },
        {
          prop: "account_id",
          align: "center",
          label: "id",
          width: "150",
          fixed: "left"
        }, {
          prop: "role_no",
          align: "center",
          label: "角色号",
          width: "150",
          fixed: "left"
        }, {
          prop: "role_name",
          align: "center",
          label: "角色名",
          width: "150",
          fixed: "left"
        }
      ]
    };
  },
  async mounted() {
    this.wtypermiss_show = false;

    try {
      const spl = await getServicePermissList();
      //服务商调用组件
      this.perssionData = {
        t2: spl.t2,
        t6: spl.t6
      }
      //TODO:改成角色
      //t = await getUsergroupList();
      //this.ugroup_list = await getServiceRoleList();
      //const res = await getServiceRoleList();
      //console.log(res);

      /* const res = await getPermissList();
      console.log("有报错：ac12");

      this.perssionData = res;

      const result = await baseinfoListAccount();
      console.log("有报错：ac123");

      this.tableList = result;
      console.log("result", result); */

      this.wtypermiss_show = true;
    } catch (e) {
      console.log("有报错：ac", e);
      this.wtypermiss_show = true;
    }
  }
};
</script>
<style scoped>
.father {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow: hidden !important;
  padding-top: 10px;
}
</style>
